import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-goals.tsx
var LazyCourseGoals = lazy(() => import("./course-goals-CmiFPM8R.js").then((n) => n.n).then((module) => ({ default: module.CourseGoals })));
function CourseGoals({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-goals" }),
		children: /* @__PURE__ */ jsx(LazyCourseGoals, { ...props })
	});
}
function CourseGoalsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-goals" }),
		children: /* @__PURE__ */ jsx(LazyCourseGoals, { ...props })
	});
}
var useCourseGoalsContent = () => {
	return useMemo(() => ({ courseGoals: { component: CourseGoalsContent } }), []);
};
//#endregion
export { CourseGoals, useCourseGoalsContent };
